import { useNavigate } from 'react-router-dom';

import { Tickets } from './frames/tickets';


export const ButtonTickets = (): JSX.Element => {
	const navigate = useNavigate();

	const goToTicket = () => navigate('tickets');

	return (
		<div>
			<button onClick={goToTicket}>
				<Tickets />
			</button>
		</div>

	);
};
